var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4Card3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_6910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.36 10H11.3333C10.9797 10 10.6406 10.1405 10.3905 10.3905C10.1405 10.6406 10 10.9797 10 11.3333V14.36",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 2.22656V3.33323C4.66663 3.86366 4.87734 4.37237 5.25241 4.74744C5.62749 5.12252 6.13619 5.33323 6.66663 5.33323C7.02025 5.33323 7.35939 5.47371 7.60943 5.72375C7.85948 5.9738 7.99996 6.31294 7.99996 6.66656C7.99996 7.3999 8.59996 7.9999 9.33329 7.9999C9.68691 7.9999 10.0261 7.85942 10.2761 7.60937C10.5262 7.35932 10.6666 7.02018 10.6666 6.66656C10.6666 5.93323 11.2666 5.33323 12 5.33323H14.1133",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 14.633V11.9997C7.33337 11.6461 7.19289 11.3069 6.94284 11.0569C6.69279 10.8068 6.35365 10.6663 6.00003 10.6663C5.64641 10.6663 5.30727 10.5259 5.05722 10.2758C4.80718 10.0258 4.6667 9.68663 4.6667 9.33301V8.66634C4.6667 8.31272 4.52622 7.97358 4.27618 7.72353C4.02613 7.47348 3.68699 7.33301 3.33337 7.33301H1.3667",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6663C11.6819 14.6663 14.6667 11.6816 14.6667 7.99967C14.6667 4.31778 11.6819 1.33301 8.00004 1.33301C4.31814 1.33301 1.33337 4.31778 1.33337 7.99967C1.33337 11.6816 4.31814 14.6663 8.00004 14.6663Z",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_6910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4Card3);
export default __webpack_public_path__ + "static/media/Icon4card3.0176a606a5a5a7ec361f2cb7479d603c.svg";
export { ForwardRef as ReactComponent };